/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Care_Log_FertilizersInputs */

const vi_trace_care_log_fertilizers = /** @type {(inputs: Trace_Care_Log_FertilizersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phân bón`)
};

/**

* @param {Trace_Care_Log_FertilizersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_care_log_fertilizers = /** @type {((inputs?: Trace_Care_Log_FertilizersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Care_Log_FertilizersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_care_log_fertilizers(inputs)
});